import { useRouter } from 'next/router';

export const useLmsDestinationFromQuery = (): string | null => {
    const router = useRouter();

    const param: string | string[] | undefined = router.query.til;
    const destinations: string[] = param ? (Array.isArray(param) ? param : [param]) : [];

    if (destinations.length === 0) {
        return null;
    }

    const lastSelectedDestinationIndex = destinations.length - 1;

    return destinations[lastSelectedDestinationIndex];
};
